import {
  Box,
  Card,
  CardHeader,
  Divider,
  Grid,
  Typography,
} from '@material-ui/core'
import { Label } from 'components'
import useStyles from '../../styles'
import PropTypes from 'prop-types'

import helpers from 'helpers'

const ResponsibleCard = ({ responsibleUser }) => {
  const classes = useStyles()

  return (
    <Card>
      <CardHeader title="Informações do representante" />
      <Divider />
      <Box className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Label title="Nome do representante">
              <Typography>{responsibleUser?.name}</Typography>
            </Label>
          </Grid>
          <Grid item xs={12} md={4}>
            <Label title="E-mail do representante">
              <Typography>{responsibleUser?.email}</Typography>
            </Label>
          </Grid>
          <Grid item xs={12} md={4}>
            <Label title="Telefone do representante">
              <Typography>
                {helpers.formatters.phone.number(responsibleUser?.phone + '')}
              </Typography>
            </Label>
          </Grid>
        </Grid>
      </Box>
    </Card>
  )
}

ResponsibleCard.propTypes = {
  responsibleUser: PropTypes.object,
}

export default ResponsibleCard
